import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthUser {
  uid: string;
  email: string;
  name: string;
  role: 'user' | 'admin';
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthUser>) => {
      
      state.user = action.payload;
      state.loading = false;
      state.error = null;
     
    },
    clearUser: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
     
      state.loading = action.payload;
      
    },
    setError: (state, action: PayloadAction<string>) => {

      state.error = action.payload;
      state.loading = false;
      
    },
    logout: (state) => {
     
      state.user = null;
      state.loading = false;
      state.error = null;
      
      
    },
  },
});

export const { setUser, clearUser, setLoading, setError, logout } = authSlice.actions;
export default authSlice.reducer;